import { compact, uniq } from 'lodash';

import { ShipmentJourneyModel } from '@/lib/models/shipment-journey/types';
import { PortApiInterface } from '@/types/api-types';

/**
 * Extracts the full Port Item if it exists in the correct order
 */
export const getUniquePortsFromShipmentJourney = (journey?: ShipmentJourneyModel): PortApiInterface[] => {
  if (!journey) return [];

  const { ports: portDictionary } = journey;
  const portIds = getUniquePortIdsFromShipmentJourney(journey);
  return portIds.map((portId) => {
    return portDictionary[portId];
  });
};

/**
 * Extracts just the PortIds (aka NodeIds) in the correct order
 */
export const getUniquePortIdsFromShipmentJourney = (journey?: ShipmentJourneyModel): string[] => {
  if (!journey) return [];

  const { segments } = journey;

  const portIds: string[] = segments.reduce((accum, segment) => {
    const segmentPortIds = segment.locations.map((l) => l.portId || null);
    return [...accum, ...compact(segmentPortIds)];
  }, [] as string[]);

  return uniq(portIds);
};
